import { useAccount } from './UseAccount';

export const useSubscription = () => {
	const account = useAccount();

	return (
		account?.is_subscription === true ||
		account?.is_subscription === 1 ||
		account?.is_subscription === '1'
	);
};
